import { ArrowRightIcon } from "@radix-ui/react-icons"
import Link from "next/link"
import { DynamicHeadline } from "../DynamicHeadline"
import styles from "./LinkList.module.scss"
import { LinkListItem } from "./LinkListItem"
import Section, { parseColors } from "components/Section"

export const LinkList = ({ data = {}, colors }) => {
  const {
    links,
    show_button: showButton,
    button_link: buttonLink,
    button_new_tab: buttonNewTab,
    dynamic_headline: dynamicHeadline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
  } = data

  const { accent } = parseColors({ colors })

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      colors={colors}
    >
      <div className={styles.headlineWrapper}>
        <DynamicHeadline
          headlineType={headlineType?.value}
          headlineAppearance={headlineAppearance?.value}
          className={`${styles.headline}`}
        >
          {dynamicHeadline}
        </DynamicHeadline>
      </div>
      <div className={styles.linksWrapper}>
        {links &&
          links.map((link, i) => (
            <LinkListItem key={i} item={link} color={accent.color} />
          ))}
        <div className={styles.blogLinkWrapper}>
          {showButton && buttonLink && (
            <Link href={buttonLink}>
              <a
                className={styles.blogLink}
                target={buttonNewTab ? "_blank" : "_self"}
              >
                <ArrowRightIcon />
              </a>
            </Link>
          )}
        </div>
      </div>
    </Section>
  )
}

export default LinkList
